import { Authenticator, useAuthenticator } from '@aws-amplify/ui-react';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useAuth } from '../hooks';
import '@aws-amplify/ui-react/styles.css';
import './AuthPage.css';

// Inner component to handle redirect after auth
function AuthRedirect() {
  const navigate = useNavigate();
  const { authStatus } = useAuthenticator((context) => [context.authStatus]);

  useEffect(() => {
    if (authStatus === 'authenticated') {
      navigate('/simulator');
    }
  }, [authStatus, navigate]);

  return null;
}

function AuthPage() {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading } = useAuth();

  useEffect(() => {
    // Redirect to simulator page if already authenticated
    if (!isLoading && isAuthenticated) {
      navigate('/simulator');
    }
  }, [isAuthenticated, isLoading, navigate]);

  return (
    <div className="auth-page">
      <div className="auth-container">
        <Authenticator
          signUpAttributes={['email']}
          formFields={{
            signUp: {
              email: {
                order: 1,
                placeholder: 'Enter your email',
                label: 'Email',
                isRequired: true,
              },
              password: {
                order: 2,
                placeholder: 'Create a password',
                label: 'Password',
                isRequired: true,
              },
              confirm_password: {
                order: 3,
                placeholder: 'Confirm your password',
                label: 'Confirm Password',
                isRequired: true,
              },
            },
          }}
        >
          <AuthRedirect />
        </Authenticator>
      </div>
    </div>
  );
}

export default AuthPage;
